import styled from 'styled-components'

export const Container = styled.section`
  width: 100%;
  height: 245px;
  display: flex;
  align-items: center;
  background-color: #000;

  @media only screen and (min-width: 0px) and (max-width: 768px) {
    height: 294px;
  }
`

export const Content = styled.div`
  width: 750px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  text-align: center;

  h2 {
    color: #f5f5f5;
  }

  form {
    width: 550px;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: row wrap;
  }

  input {
    height: 43px;
    background-color: var(--color-primary);
    border: none;
    outline: none;
    padding: 5px 1rem;
    width: 16.5rem;
    color: var(--color-reverse);

    &:not(:focus) {
      font-style: italic;

      border-left: 0px solid var(--color-secondary);
      transition: border-left 0.25s ease-in-out;
      color: var(--color-primaryCompliment);
    }

    &:focus {
      ::placeholder {
        color: transparent;
      }

      border-left: 6px solid var(--color-secondary);
      transition: border-left 0.25s ease-in-out;
    }
  }

  button {
    height: 43px;
    background-color: var(--color-secondary);
    padding: 0.5rem 5.5rem;
    font-family: 'Bungee';
    font-size: 0.9rem;
    border: none;
    cursor: pointer;
    color: #000;

    &:hover,
    &:focus {
      background-color: var(--color-secondary);
    }
  }

  @media only screen and (min-width: 368px) and (max-width: 767px) {
    width: 100%;
    justify-content: space-evenly;

    div {
      width: 265px;
    }

    form {
      width: 265px;
      justify-content: space-evenly;
    }

    h2 {
      line-height: 1.3;
    }

    button {
      margin: 1rem 0rem;
    }
  }

  @media only screen and (min-width: 0px) and (max-width: 367px) {
    width: 90%;
    justify-content: space-evenly;

    div {
      width: 90%;
    }

    form {
      width: 95%;
      justify-content: space-evenly;
      margin: 0 auto;

      span {
        width: 100%;
      }

      input {
        width: 100%;
      }
    }

    h2 {
      line-height: 1.3;
    }

    button {
      width: 100%;
      margin: 1rem 0rem;
      padding: 0.5rem 0rem;
    }
  }
`

export const CommunitySpan = styled.span`
  font-family: 'Bungee';
  color: var(--color-secondary);
  letter-spacing: 2px;
`
